<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <multiselect
                        v-model="search.sale_id"
                        class="form-control select"
                        placeholder="เซลล์"
                        :options="optionSeller"
                        :show-labels="false"
                        label="name"
                        track-by="name"
                        style="border: none">
                    </multiselect>
                    <date-picker
                        v-model="search.date"
                        type="date"
                        :format="changeFormat"
                        :lang="lang"
                        range
                        confirm
                        class="col-2"
                        placeholder="วันที่">
                    </date-picker>&nbsp;&nbsp;
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchMileSeller(1)"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    <button class="btn btn-success my-2 my-sm-0 ml-2"
                            @click="printMileSeller"
                            type="button">
                        <icon name="print"></icon> รายงานคำนวนไมล์
                    </button>
                    <button class="btn btn-warning my-2 my-sm-0 ml-2"
                            @click="showcalculateModal(null)"
                            type="button">
                        <icon name="plus"></icon> เพิ่มคำนวนไมล์
                    </button>
                </form>
            </div>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered" style="text-align: center">
                <thead>
                <tr>
                    <th>ชื่อคนรถ</th>
                    <th>วันที่</th>
                    <th>ค่าน้ำมัน</th>
                    <th>ไมล์รถออกจากโรงงาน</th>
                    <th>ไมล์รถเข้าโรงงาน</th>
                    <th>ระยะทางที่ใช้ (ก.ม.)</th>
                    <th>เฉลี่ยใช้แก๊ซ/น้ำมมัน (ก.ม.)</th>
                    <th>เฮียให้ใช้ได้</th>
                    <th>เซลล์ใช้แก๊ซ/น้ำมันเกิน</th>
                    <th>ยอดต่าง</th>
                    <th>แก้ไขข้อมูล</th>
                    <th>ลบข้อมูล</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in MileSellerTable">
                    <td>{{item.sale_id}}-{{item.name}}</td>
                    <td>
                        <template v-if="item.date">
                            {{item.date | moment("DD/MM/YYYY")}}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <td>{{item.gas_car_fee | currency}}</td>
                    <td>{{item.mile_warehouse_out | currency}}</td>
                    <td>{{item.mile_warehouse_in | currency}}</td>
                    <td>{{item.distance_total | currency}}</td>
                    <td>{{item.average_mile | currency}}</td>
                    <td>{{item.free_km | currency}}</td>
                    <td>{{item.over_gas_fee | currency}}</td>
                    <td>{{Number(diff_total(item.distance_total,item.over_gas_fee).toFixed(0))}}</td>
                    <td>
                        <button type="button" class="btn btn-info" @click="showcalculateModal(item.id)">
                            <icon name="pencil-alt"></icon>
                            แก้ไข
                        </button>
                    </td>
                    <td>
                        <button type="button" class="btn btn-danger" @click="showModalDelete(item.id)">
                            <icon name="trash"></icon>
                            ลบ
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="MileSellerTable.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getMileSellerTable(dataPaginate.current_page)">
            </vue-pagination>
        </div>
        <b-modal
                ref="calculate_mile"
                hide-header
                hide-footer>
            <div style="text-align: center;">
                <h4>เพิ่มข้อมูล</h4>
                <br/>
                <div class="row form-group">
                    <div class="col-4 text-right">ชื่อคนรถ</div>
                    <div class="col-6" style="padding: 0 30px 0 9px">
                        <multiselect
                                v-model="calculate.sale"
                                class="form-control border-0"
                                placeholder="ค้นหาคนขับ"
                                :options="optionSeller"
                                label="name"
                                :show-labels="false"
                                track-by="id">
                        </multiselect>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-4 text-right">วันที่</div>
                    <div class="col-6">
                        <date-picker
                                v-model="calculate.date"
                                type="date"
                                :lang="lang"
                                format="DD-MM-YYYY"
                                placeholder="วันที่"
                                confirm>
                        </date-picker>
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-4 text-right">ค่าน้ำมัน</div>
                    <div class="col-6">
                        <input type="number" class="form-control" v-model="calculate.gas_car_fee"/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-4 text-right">ไมล์รถออกจากโรงงาน</div>
                    <div class="col-6">
                        <input type="number" class="form-control" v-model="calculate.mile_warehouse_out"/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-4 text-right">ไมล์รถเข้าโรงงาน</div>
                    <div class="col-6">
                        <input type="number" class="form-control" v-model="calculate.mile_warehouse_in"/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-4 text-right">เฮียให้ใช้</div>
                    <div class="col-6">
                        <input class="form-control" v-model="calculate.free_km"/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-4 text-right"><span>ระยะทางที่ใช้ (ก.ม.)</span></div>
                    <div class="col-6">
                        <input class="form-control" v-model="calculet_oil" readonly/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-4 text-right"><span>เฉลี่ยใช้น้ำมัน (ก.ม.)</span></div>
                    <div class="col-6">
                        <input class="form-control" v-model="calculet_avg" readonly/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-4 text-right">เซลล์ใช้แก๊ซ/น้ำมันเกิน</div>
                    <div class="col-6">
                        <input class="form-control" v-model="calculet_end" readonly/>
                    </div>
                </div>
                <br/>
                <button type="button"
                        class="btn btn-success"
                        @click="sendSave()">
                    <icon name="print" style="width: 25px"></icon>
                    ตกลง
                </button>
                <button type="button"
                        class="btn btn-secondary ml-5"
                        @click="hidecalculateModal()">
                    <icon name="times"></icon>
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <b-modal
                ref="delete_item"
                hide-header
                hide-footer>
            <div style="text-align: center;">
                <h4>คุณต้องการลบใช่หรือไม่</h4>
                <br/>
                <button type="button"
                        class="btn btn-success"
                        @click="DeleteConfirm()">ตกลง
                </button>
                &nbsp&nbsp
                <button type="button"
                        class="btn btn-secondary"
                        @click="hideModalDelete()">ยกเลิก
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker'
    import { mapState } from "vuex";
    import Multiselect from "vue-multiselect";
    import moment from "moment"
    import VuePagination from "../../../components/Pagination";
    import {domain} from "../../../util/Constants";

    export default {
        name: "MileSellerCarList",
        created(){
            this.getMileSellerTable(1);
            this.$store.dispatch("Seller/get");
        },
        components:{
            DatePicker,
            Multiselect,
            moment,
            VuePagination,
        },
        computed:{
        ...mapState({
                optionSeller:state=>{
                    return state.Seller.data
                },
                user : state=>{
                    return state.Auth.user;
                },
            }),
            calculet_oil(){
                this.calculate.distance_total = 0;
                if(this.calculate.mile_warehouse_out && this.calculate.mile_warehouse_in){
                    this.calculate.distance_total = parseFloat(this.calculate.mile_warehouse_in - this.calculate.mile_warehouse_out).toFixed(2);
                }
                return this.calculate.distance_total;
            },
            calculet_avg(){
                this.calculate.average_mile = 0;
                if(this.calculate.gas_car_fee && this.calculate.distance_total){
                    this.calculate.average_mile = parseFloat(this.calculate.gas_car_fee / this.calculate.distance_total).toFixed(4);
                }
                return this.calculate.average_mile;
            },
            calculet_end(){
                this.calculate.over_gas_fee = 0;
                if(this.calculate.average_mile && this.calculate.free_km){
                    this.calculate.over_gas_fee = parseFloat(this.calculate.average_mile - this.calculate.free_km).toFixed(4);
                }
                return this.calculate.over_gas_fee;
            },
        },
        data(){
            return{
                delete_id:'',
                edit_id:'',
                calculate:{
                    id:'',
                    sale:'',
                    date:'',
                    gas_car_fee:'',
                    mile_warehouse_out:'',
                    mile_warehouse_in:'',
                    distance_total:'',
                    average_mile:'',
                    free_km:'',
                    over_gas_fee:'',
                },
                search:{
                    sale_id : '',
                    date : ''
                },
                MileSellerTable : [],
                changeFormat: {
                    stringify: (date) => {
                        let date_moment = moment(date).format('YYYY');
                        const year = parseInt(date_moment) + 543;
                        return date ? moment(date).format('DD/MM/'+year) : null
                    },
                    parse: (value) => {
                        return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                    }
                },
                lang: {
                    days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                    months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                    pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                    placeholder: {
                        date: 'วว/ดด/ปปปป',
                    }
                },
                dataPaginate:{
                    current_page :1,
                    from : 1,
                    last_page : 1,
                    per_page : 1,
                    total : 1,
                    to : 1
                },
            }
        },
        methods:{
            diff_total(total,over){
                if(Number((total).toFixed(2))*Number((over).toFixed(2)) <= 0)return 0;
                else return Number((total).toFixed(2))*Number((over).toFixed(2));
            },
            printMileSeller(){
                let start_date = '';
                let end_date = '';
                if(this.search.date.length > 0 && this.search.date[0]){
                    start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                    end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
                }
                let sale_id = this.search.sale_id ? this.search.sale_id.id : '';
                window.open( `${domain}/mileSellerPDF?sale_id=${sale_id}` +
                    `&start_date=${start_date}&end_date=${end_date}`,'_blank');
            },
            searchMileSeller(page){
                let start_date = '';
                let end_date = '';
                if(this.search.date.length > 0 && this.search.date[0]){
                    start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                    end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
                }
                let sale_id = this.search.sale_id ? this.search.sale_id.id : '';
                this.event_submit = true;
                let data = {
                    sale_id,
                    start_date,
                    end_date,
                };
                this.$store.dispatch('Account/getMileSeller', {page,data}).then(res=>{
                    this.MileSellerTable = res.data;
                });
            },
            DeleteConfirm(){
                this.$store.dispatch('Account/deleteMileSeller',this.delete_id).then(()=>{
                    this.getMileSellerTable(1);
                    this.$refs.delete_item.hide();
                });
            },
            hideModalDelete(){
                this.$refs.delete_item.hide();
            },
            showModalDelete(id){
                this.delete_id = id;
                this.$refs.delete_item.show();
            },
            showcalculateModal(id){
                this.clear_search();
                if(!id){
                    this.$refs.calculate_mile.show();
                }
                else{
                    this.$store.dispatch("Account/getMileSellerById",id).then(res=>{
                        this.calculate = res;
                    });
                    this.calculate.id = id;
                    this.$refs.calculate_mile.show();
                }
            },
            hidecalculateModal(){
                this.$refs.calculate_mile.hide();
            },
            sendSave(){
                if(!this.calculate.sale) alert('กรุณากรอกคนรถ');
                else if(!this.calculate.date)alert('กรุณากรอกวันที่');
                else if(!this.calculate.gas_car_fee)alert('กรุณากรอกค่าน้ำมัน');
                else if(!this.calculate.mile_warehouse_out)alert('กรุณากรอกไมล์รถออกจากโรงงาน');
                else if(!this.calculate.mile_warehouse_in)alert('กรุณากรอกไมล์รถเข้าโรงงาน');
                else if(!this.calculate.free_km)alert('กรุณากรอกเฮียให้ใช้');
                else {
                    this.calculate.sale = this.calculate.sale.id;
                    this.calculate.date = moment(this.calculate.date).format("YYYY-MM-DD");
                    if(this.calculate.id == ''){
                        this.$store.dispatch("Account/saveMileSeller",
                            {
                                id : null ,
                                data:this.calculate
                            }).then(()=>{
                            this.clear_search();
                            this.getMileSellerTable(1);
                            this.$refs.calculate_mile.hide();
                        });
                    }else{
                        this.$store.dispatch("Account/saveMileSeller",{
                            id : this.calculate.id,
                            data : this.calculate
                        }).then(()=>{
                            this.clear_search();
                            this.getMileSellerTable(1);
                            this.$refs.calculate_mile.hide();
                        });
                    }
                }
            },
            clear_search(){
                this.calculate = {
                    id : '',
                    sale_id:'',
                    date:'',
                    gas_car_fee:'',
                    mile_warehouse_out:'',
                    mile_warehouse_in:'',
                    distance_total:'',
                    average_mile:'',
                    free_km:'',
                    over_gas_fee:'',
                };
            },
            getMileSellerTable(page){
                let start_date = '';
                let end_date = '';
                if(this.search.date.length > 0 && this.search.date[0]){
                    start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                    end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
                }
                let sale_id = this.search.sale_id ? this.search.sale_id.id : '';
                let data = {
                    sale_id,
                    start_date,
                    end_date,
                };
                this.$store.dispatch('Account/getMileSeller',{page,data}).then(res=>{
                    this.MileSellerTable = res.data;
                });
            }
        },
    }

</script>

<style scoped>

</style>
